module.exports = __webpack_public_path__ + "f7b8841bdf660b48e104d7bbbb70dc4b.png";